// Generic authenticated-user permission helpers.
//
// Presentation authority only.
// Backend permission guards remain the final security authority.

export function normalizePermissions(permissions) {
  if (!Array.isArray(permissions)) {
    return [];
  }

  return permissions.filter(
    (permission) =>
      typeof permission === "string"
      && permission.length > 0
  );
}

export function hasPermission(user, permission) {
  if (
    !user
    || typeof permission !== "string"
    || permission.length === 0
  ) {
    return false;
  }

  return normalizePermissions(
    user.permissions
  ).includes(permission);
}

export function hasEveryPermission(
  user,
  permissions
) {
  return normalizePermissions(
    permissions
  ).every(
    (permission) =>
      hasPermission(user, permission)
  );
}

export function hasAnyPermission(
  user,
  permissions
) {
  return normalizePermissions(
    permissions
  ).some(
    (permission) =>
      hasPermission(user, permission)
  );
}
